/** Member nav model — 8 top tabs. */

export type MemberScreenId =
  | 'u-dashboard'
  | 'u-activity'
  | 'u-badges'
  | 'u-campaigns'
  | 'u-store'
  | 'u-leaderboard'
  | 'u-howto'
  | 'u-privacy';

export interface MemberNavItem {
  id: MemberScreenId;
  /** English fallback used by `t()` when no translation is registered. */
  label: string;
  /** Language key (resolved against the INI via `t()`). */
  labelKey: string;
  /**
   * Visibility key in `joomlaOptions().nav` (admin Settings → Navigation). When
   * set, the tab is hidden if that flag is explicitly false. Always-on tabs
   * (overview, my rewards, badges) omit it.
   */
  gate?: 'campaigns' | 'store' | 'leaderboard' | 'howto' | 'privacy';
}

export const USER_NAV: MemberNavItem[] = [
  { id: 'u-dashboard', label: 'Overview', labelKey: 'COM_REWARDIFY_MNAV_DASHBOARD' },
  { id: 'u-activity', label: 'My rewards', labelKey: 'COM_REWARDIFY_MNAV_ACTIVITY' },
  { id: 'u-badges', label: 'Badges', labelKey: 'COM_REWARDIFY_MNAV_BADGES' },
  { id: 'u-campaigns', label: 'Campaigns', labelKey: 'COM_REWARDIFY_MNAV_CAMPAIGNS', gate: 'campaigns' },
  { id: 'u-store', label: 'Catalogue', labelKey: 'COM_REWARDIFY_MNAV_STORE', gate: 'store' },
  { id: 'u-leaderboard', label: 'Leaderboard', labelKey: 'COM_REWARDIFY_MNAV_LEADERBOARD', gate: 'leaderboard' },
  { id: 'u-howto', label: 'How to earn', labelKey: 'COM_REWARDIFY_MNAV_HOWTO', gate: 'howto' },
  { id: 'u-privacy', label: 'Privacy', labelKey: 'COM_REWARDIFY_MNAV_PRIVACY', gate: 'privacy' },
];

/** USER_NAV filtered by the admin nav-visibility flags (missing flag = visible). */
export function visibleUserNav(nav: Record<string, boolean>): MemberNavItem[] {
  return USER_NAV.filter((n) => !n.gate || nav[n.gate] !== false);
}
